export default "__VITE_ASSET__CJFlVvce__"